/* hs-eslint ignored failing-rules */

import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { fetchBannerInfo } from '../api/accountVerification';
import SuspensionBannersContext from '../contexts/suspensionBannersContext';
import useBanner from '../hooks/useBanner';
import { sourceAppValues } from '../types';
import Banner from './Banner';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const AccountVerificationContextBanner = ({
  scope,
  source
}) => {
  const [fetchFinished, setFinishedFetching] = useState(false);
  const {
    bannerInfo,
    setBannerInfo,
    bannerHiddenByUserFor,
    setBannerHiddenByUserFor
  } = useContext(SuspensionBannersContext);
  const {
    showBanner,
    showCta,
    alertType,
    langPath,
    redirectUrl,
    closable
  } = useBanner(bannerHiddenByUserFor(scope), bannerInfo(scope));
  useEffect(() => {
    if (scope) {
      const sourceURL = window.location.href;
      fetchBannerInfo(scope, sourceURL).then(banner => setBannerInfo(scope)(banner)).catch(console.error).finally(() => setFinishedFetching(true));
    }
  }, [scope, source]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (fetchFinished && !closable) {
      setBannerHiddenByUserFor(scope)(false);
    }
  }, [fetchFinished, closable]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!showBanner) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(Banner, {
    redirectUrl: redirectUrl,
    alertType: alertType,
    showCta: showCta,
    langPath: langPath,
    closable: closable,
    onClose: () => setBannerHiddenByUserFor(scope)(true)
  });
};
AccountVerificationContextBanner.propTypes = {
  scope: PropTypes.string.isRequired,
  source: PropTypes.oneOf(sourceAppValues).isRequired
};
export default AccountVerificationContextBanner;